import { AdminTitle } from "../../../../store/reducers/site";

import React, { useState, useCallback } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import { useParams } from 'react-router-dom';
import { getShopImagesbyID } from "../../../../store/actions/shopAction";
import Divider from '@mui/material/Divider' ;
import ImageUpload from "./imageUpload";
import { useDispatch,useSelector} from 'react-redux' 
import { useEffect } from 'react';
import { render } from 'react-dom';
import { Loader } from '../../../../utils/tools';
import StatusChange from '../../../../utils/statusChange';
import { getUserData } from '../../../../utils/tools';
import { ImageList,ImageListItem  } from '@mui/material';
import { shopImageStatusChange } from "../../../../store/actions/shopAction";
import { useNavigate } from 'react-router-dom'
import ErrorBoundary from '../../../../utils/ErrorBoundary';
import ImageStatusChange from "../../shops/editShops/imageStatusChange1";
import { LinkContainer } from 'react-router-bootstrap'
import {
  
  Button,
  ButtonGroup


} from 'react-bootstrap';


const OnlineItemImageUpload= () =>{
  const articles = useSelector(state=>state.shopReducer);
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [loading,setLoading] = useState(true);
    //const [imageList, setimageList] = useState();
    const [imageList, setimageList] = useState([]);
    const navigate = useNavigate();
    //const [currentImage1, setCurrentImage1] = useState();
   
    let { articleId } = useParams();
    const dispatch = useDispatch();
    const news1 = useSelector(state=>state.shopReducer);
    //let imgUrl='/dashboard/shop/adress/'+articleId;
  
    let imgUrl='/dashboard/shop/adress/'+articleId;
    let adrssViewUrl='/dashboard/items';

    const goToNewsAproval = (id,trnsNo1,status) => {
      //navigate(`/dashboard/articles/edit/${id}`)
      



      const data = {
        shopId:id,
        approved:getUserData().userId,
        trsnNo:trnsNo1,
        status:"FAD"
         
        
    };
    const addURL="api/shpimgs/aprve";
    
      
    dispatch(shopImageStatusChange({data,addURL}))
     .unwrap()
   .then(()=>{
    //   //navigate(`/dashboard/articlesOfc/article/${id}`)
    window.location.reload();
      
      
    })
      

     
  }

  const goToNewsPublish = (id,trnsNo1,status) => {
    console.log("$$$$$$$$$$$$$$$")
    //console.log()
      console.log(news1)
      console.log("$$$$$$$$$$$$$$$")
      //dispatch(getPaginateArticles({page}))
      const data = {
        shopId:id,
        approved:getUserData().userId,
        trsnNo:trnsNo1,
        status:"PSD"
         
        
    };
    const addURL="api/shpimgs/pblsh";
      

dispatch(shopImageStatusChange({data,addURL}))
             .unwrap()
             .then(()=>{
              // navigate(`/dashboard/articlesOfc/article/${id}`)
              window.location.reload();
              
             })
      
  }  

  const goToNewsBlock = (id,trnsNo1,status) => {
      //console.log(page)
      
      const data = {
        shopId:id,
        approved:getUserData().userId,
        trsnNo:trnsNo1,
        status:"BLK"
         
        
    };
    const addURL="api/shpimgs/block";
      


dispatch(shopImageStatusChange({data,addURL}))
            .unwrap()
             .then(()=>{
             // navigate(`/dashboard/articlesOfc/article/${id}`)
             window.location.reload();
              
           })
  }  
   
    let images12=[];
     
    useEffect(()=>{
       

        console.log("1111155656565");
        console.log(articleId);
   

let myArray = articleId.split("_");
let id1= myArray[0];

console.log("1111155656565");
console.log(myArray[0]);
console.log("1111155656565");
        
        dispatch(getShopImagesbyID(id1))
        .unwrap()
        .then(response => {

             
            console.log("55656565");
            console.log(response);
            console.log(response);
            
            console.log("56565656");
           
            //setLoading(false);
           
         
            
                //const data = JSON.parse(formData);
               

                //images12=[];
                response.imageList.map((item)=>(
                  // key={transactionNo
                  // },
                 

                  
                    //images12.push(item.imageUrl)
                    images12 = images12.concat(item.imageUrl)
                ))
                setimageList(images12);
                setLoading(false);
                
                console.log("43434343");
                console.log(imageList.length);
                console.log(news1.images.length);
                
                console.log("43434343");
             
           
        })

    },[dispatch,articleId])

    //const images =news1.images;
    

     




      const openImageViewer = useCallback((index) => {
        
        setCurrentImage(index);
         setIsViewerOpen(true);
      }, []);
    
      const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
      };
    
      return (
        
        <>
        
          {loading ?
          <div>
          <h1>hjhjhjh</h1>
                <Loader/>
                </div>
                
            :
           
        <div>
       {(news1.images.length > 0) ?

<div>
        
{ 

imageList.map((src, index) => (
  <>
  <div>
  <Divider className='mt-3 mb-3'/>

  {console.log("test44444")}
  {console.log(imageList.length)}
  {console.log("test4444466666666")}
  {console.log(articles.current)}
  {console.log(src)}

  {console.log("test44444")}
  <img
    src={src}
    onClick={ () => openImageViewer(index) }
    width="300"
    key={ index }
    style={{ margin: '2px' }}
    alt=""
  />
 

  </div>
  <div>
 


  <h3>{news1.images[index].title}</h3>
       <h4>{news1.images[index].status}</h4>
 
       <ImageStatusChange
          articles={news1.images[index]}
          type="Image"
          goToNewsAproval={(id)=> goToNewsAproval(news1.images[index].shopId,news1.images[index].trsnNo,news1.images[index].status)}
          goToNewsPublish={(id)=> goToNewsPublish(news1.images[index].shopId,news1.images[index].trsnNo,news1.images[index].status)}
          goToNewsBlock={(id)=> goToNewsBlock(news1.images[index].shopId,news1.images[index].trsnNo,news1.images[index].status)}
          status={news1.images[index].status}
      />

  
      </div>
  </>
  
))}

{isViewerOpen && (
  <ImageViewer
  
  currentIndex={ currentImage }
  src={ imageList }
  disableScroll={ false }
  closeOnClickOutside={ true }
    onClose={ closeImageViewer }
  />
)}


<Divider className='mt-3 mb-3'/>
</div>

:null }
      


</div>
    
}
<div>

{(news1.images.length<5)?

       <ImageUpload/>
    :null}
</div>


<div className='form-group'></div>
        <ButtonGroup className='me-2'>
                    <LinkContainer to={adrssViewUrl}>
                        <Button 
                        variant='link'
                        color="orange"
                        >
                            Next
                            </Button>
                    </LinkContainer>
                </ButtonGroup>
</>
        
      );

}
export default OnlineItemImageUpload;
// redux




